import * as React from 'react'

import Svg, { Rect, Path } from 'react-native-svg'

import { IconProps } from '../icons'

const GirlWithShortHairProfile = ({
  size = 36,
  color = '#596379',
  ...props
}: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 36 36"
    fill="none"
    {...props}
  >
    <Rect x={0.5} y={0.5} width={35} height={35} rx={17.5} fill="#fff" />
    <Path
      d="M13.732 20.036c.951.142 2.112-.076 3.38-.152.236.053.473.09.718.09.25 0 .496-.037.741-.095 3.3.161 5.871 1.094 5.871-5.62C24.442 9.7 21.482 6 17.83 6c-3.651 0-6.611 3.7-6.611 8.259 0 3.665.7 5.09 1.839 5.585.21.098.438.156.674.192Zm-1.053-8.353c.691.96 2.486.755 4.035-.46.393-.308.737-.66 1.014-1.018a.886.886 0 0 1 .107.018c.152.027.29.08.446.13.139.067.29.12.424.205.139.072.264.17.389.255.111.098.236.191.33.299.098.098.192.205.264.308.08.098.138.2.196.29.058.09.107.17.134.24l.107.22-.04-.241a2.222 2.222 0 0 0-.058-.277c-.027-.107-.058-.232-.112-.357a3.426 3.426 0 0 0-.178-.407c-.067-.143-.166-.28-.26-.433-.111-.138-.214-.29-.348-.424-.125-.143-.276-.263-.424-.393-.138-.098-.285-.205-.442-.29.067-.138.12-.281.165-.415.554.25 1.121.567 1.572 1.018 1.656 1.656 1.004 3.58 2.281 2.308.201-.201.366-.41.496-.62.044 0 .089-.005.125.004a.587.587 0 0 1 .348.286c.174.29.214.71.107 1.129-.16.625-.571.996-.902 1.036l-.267.036-.072.263c-.634 2.299-2.344 4.745-4.277 4.745-1.933 0-3.638-2.446-4.276-4.745l-.072-.264-.268-.035c-.326-.045-.74-.415-.902-1.036-.107-.42-.066-.84.108-1.13a.6.6 0 0 1 .25-.245ZM22.8 20.638c-.519.884-1.121 1.63-1.916 2.04-1.643.84-2.866 1.527-2.866 1.527l-.005-.004v-.014l-.013.01-.013-.01v.014l-.005.004s-1.219-.678-2.866-1.526c-.795-.411-1.393-1.157-1.915-2.04-2.433.99-4.13 3.258-4.13 5.245V30h17.857v-4.116c0-1.982-1.7-4.255-4.129-5.246Z"
      fill={color}
    />
    <Rect x={0.5} y={0.5} width={35} height={35} rx={17.5} stroke="#D1D9E9" />
  </Svg>
)

export default GirlWithShortHairProfile
